import RoomSessionStorage from './sessionStorage';
import { withQuestionLocale } from './gameLocale';

/** Host-only socket events — auto-attach hostToken when present in session. */
const HOST_AUTH_EVENTS = new Set([
  'start-game',
  'change-game-type',
  'return-to-waiting',
  'pause-game',
  'host-skip-question',
  'skip-broken-image',
  'update-room-settings',
  'generate-company-questions',
  'email-company-questions',
  'add-custom-company-question',
  'update-company-questions',
  'host-leave-as-player',
  'bonus-puzzle-set-image',
  'set-player-team',
  'spawn-ai-bot',
  'remove-ai-bot',
]);

/**
 * Enrich outbound payloads: question locale for create/start, hostToken for host mutations.
 */
export function withHostAuthPayload(event: string, data: any): any {
  let payload = data ?? {};
  if (typeof payload !== 'object' || payload === null || Array.isArray(payload)) {
    return payload;
  }

  if (event === 'create-room' || event === 'start-game') {
    payload = withQuestionLocale(payload);
  }

  if (HOST_AUTH_EVENTS.has(event) && !payload.hostToken) {
    const hostToken = RoomSessionStorage.getHostToken();
    if (hostToken) {
      payload = { ...payload, hostToken };
    }
  }

  return payload;
}
